import {
  AccordionPanel as ChakraAccordionPanel,
  AccordionPanelProps as ChakraAccordionPanelProps
} from '@chakra-ui/react';
import React from 'react';

import DisplayNames from './enums';

import { forwardRef } from 'system';

export type AccordionPanelProps = ChakraAccordionPanelProps;

const AccordionPanel = forwardRef(
  (props: AccordionPanelProps, ref: React.MutableRefObject<HTMLDivElement>): React.ReactElement => {
    const { children, ...rest } = props;

    return (
      <ChakraAccordionPanel {...rest} ref={ref}>
        {children}
      </ChakraAccordionPanel>
    );
  }
);

AccordionPanel.displayName = DisplayNames.AccordionPanel;

export default AccordionPanel;
